import colors from '../../foundations/colors.module.scss';
import { getTestIds } from '../../utils/TestIds';
export const inlineSelectDatePickerTriggerColor = (params)=>{
    if (params.isDisabled) return colors.dark500;
    if (params.showError) return colors.red950;
    return params.skin === 'primary' ? colors.purple800 : colors.dark900;
};
export const toDate = (value)=>{
    if (value == null) return null;
    const date = value instanceof Date ? value : new Date(value);
    return isNaN(date.getTime()) ? null : date;
};
export const GetInlineSelectDatePickerTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            InlineSelectDatePickerTestIds: {
                Btn: (testId)=>testId ? "".concat(testId, "-btn") : '',
                Input: (testId)=>testId ? "".concat(testId, "-input") : '',
                Tooltip: (testId)=>testId ? "".concat(testId, "-tooltip") : '',
                Clear: (testId)=>testId ? "".concat(testId, "-clear") : '',
                Popover: (testId)=>testId ? "".concat(testId, "-popover") : ''
            }
        }
    });
